import { SystemTypes } from "../../../../Definitions";
import { Pen, Section, Station } from "../../../../Definitions/newSectionModalInterfaces";
import { CreatePanelLocation, CreateTerminalLink } from "../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/createLfSectionCall";

export const transformData = (contents: Pen[] | Station[], section: Section, systemType: SystemTypes): CreatePanelLocation[] => {
  return contents.filter((content) => {
    if (systemType === SystemTypes.freedaLf) {
      return (content as Pen).penId !== null;
    }
  
    if (systemType === SystemTypes.freedaEsf_WalkThrough) {
      return (content as Station).stationId !== null;
    }
    return false;
  }).map((content) => {
    const terminals = [{ device_id: content.io ?? 0, terminal_type: content.feederOutputConfig?.terminal_type_id, config: content.feederOutputConfig, port: content.feederOutput ?? 0 }] // TODO: Terminal types

    const waterTerminal = { device_id: content.io ?? 0, terminal_type: content.waterOutputConfig?.terminal_type_id, config: content.waterOutputConfig, port: content.waterOutput ?? 0 };
    const activatorTerminal = { device_id: content.io ?? 0, terminal_type: (content as Pen).activatorInputConfig?.terminal_type_id, config: (content as Pen).activatorInputConfig, port: ((content as Pen).activatorInput ?? 0) + 100};
    const buttonTerminal = { device_id: content.io ?? 0, terminal_type: (content as Station).buttonInputConfig?.terminal_type_id, config: (content as Station).buttonInputConfig, port: (content as Station).buttonInput ?? 0 };
    const gateMotorTerminal = { device_id: content.io ?? 0, terminal_type: (content as Station).gateMotorOutputConfig?.terminal_type_id, config: (content as Station).gateMotorOutputConfig, port: (content as Station).gateMotorOutput ?? 0 };
    const gateSensor = { device_id: content.io ?? 0, terminal_type: (content as Station).gateMotorSensorInputConfig?.terminal_type_id, config: (content as Station).gateMotorSensorInputConfig, port: (content as Station).gateSensor ?? 0 }

    if (section.water) {
      terminals.push(waterTerminal);
    }

    if (section.activator && systemType === SystemTypes.freedaLf) {
      terminals.push(activatorTerminal);
    }

    if (section.gate && systemType === SystemTypes.freedaEsf_WalkThrough) {
      terminals.push(gateMotorTerminal, gateSensor);
    }

    if (section.button && systemType === SystemTypes.freedaEsf_WalkThrough) {
      terminals.push(buttonTerminal);
    }

    return {
      visual: content.visual ?? "",
      location_name: content.name ?? "",
      terminals: terminals
    }
  })
}

export function lfExtractTerminalLinks(section: Section): CreateTerminalLink[] {
  const terminalLinks: CreateTerminalLink[] = [];

  for (let i = 0; i < section.contents.length; i++) {
    const location = section.contents[i] as Pen;

    if (!location.io || !location.feederOutput) {
      //TODO: log err?
      continue;
    }

    const feederTerminal: CreateTerminalLink = {
      device_id: location.io,
      port: location.feederOutput,
    }
    let waterTerminal: CreateTerminalLink | undefined;
    let activatorTerminal: CreateTerminalLink | undefined;

    if (location.waterOutput) {
      waterTerminal = {
        device_id: location.io,
        port: location.waterOutput,
        parent_device_id: feederTerminal.device_id,
        parent_port: feederTerminal.port
      }

      feederTerminal.next_device_id = waterTerminal.device_id;
      feederTerminal.next_port = waterTerminal.port;

      terminalLinks.push(waterTerminal);
    }

    if (location.activatorInput) {
      activatorTerminal = {
        device_id: location.io,
        port: location.activatorInput + 100, //Notice: input ports run from 100-199
        next_device_id: feederTerminal.device_id,
        next_port: feederTerminal.port
      }

      feederTerminal.parent_device_id = activatorTerminal.device_id;
      feederTerminal.parent_port = activatorTerminal.port;

      terminalLinks.push(activatorTerminal);
    }

    if (waterTerminal || activatorTerminal) { //No reason to create the link if there is nothing to be linked
      terminalLinks.push(feederTerminal);
    }

  }

  return terminalLinks;
}